"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.linkFieldSrc = void 0;
var _utils = require("../utils");
var _lodash = require("lodash");
/**
 * Returns link url and target
 *
 * @param {*} linkValue Sitecore Link Field JSON response
 * @param {*} env current environment
 *
 * @returns {{linkAlt: string, linkTarget: null, linkUrl: string}} linkUrl, linkTarget Link valid URL and Target
 */
var linkFieldSrc = linkValue => {
  if (!linkValue || (0, _lodash.isEmpty)(linkValue.href)) return {
    linkUrl: '#',
    linkTarget: null,
    linkAlt: ''
  };
  var linkhrefLCase = linkValue.href.toLowerCase();
  switch (linkValue.linktype) {
    case 'external':
      return {
        linkUrl: linkhrefLCase.includes('https:') || linkhrefLCase.includes('http:') ? linkValue.href : (0, _utils.getMMDomainUrl)(linkhrefLCase),
        linkTarget: linkValue.target === undefined || linkValue.target === '' ? null : linkValue.target,
        linkAlt: linkValue.title
      };
    case 'media':
      return {
        linkUrl: linkhrefLCase.includes('https:') || linkhrefLCase.includes('http:') ? linkhrefLCase : (0, _utils.getMMDomainUrl)(linkhrefLCase),
        linkTarget: linkValue.target === undefined || linkValue.target === '' ? null : linkValue.target,
        linkAlt: linkValue.title
      };
    case 'anchor':
      return {
        linkUrl: linkValue.href,
        linkTarget: linkValue.target === undefined || linkValue.target === '' ? null : linkValue.target,
        linkAlt: linkValue.title
      };
    case 'internal':
      if (linkhrefLCase.includes('media-library')) {
        var mediaUrl = (0, _lodash.split)(linkhrefLCase, 'media-library');
        return {
          linkUrl: (0, _utils.getMMDomainUrl)("/global/media" + mediaUrl[1]),
          linkTarget: linkValue.target === undefined || linkValue.target === '' ? null : linkValue.target,
          linkAlt: linkValue.title
        };
      } else {
        var anchorTag = linkValue.anchor && !(0, _lodash.isEmpty)(linkValue.anchor) ? (0, _lodash.startsWith)(linkValue.anchor, '#') ? linkValue.anchor : "#".concat(linkValue.anchor) : '';
        return {
          linkUrl: "".concat((0, _lodash.replace)(linkhrefLCase, '/en/', '/')).concat(anchorTag),
          linkTarget: linkValue.target === undefined || linkValue.target === '' ? null : linkValue.target,
          linkAlt: linkValue.title
        };
      }
    case 'mailto':
      return {
        linkUrl: linkValue.href,
        linkTarget: null,
        linkAlt: linkValue.text
      };
    default:
      return {
        linkUrl: '#',
        linkTarget: null,
        linkAlt: ''
      };
  }
};
exports.linkFieldSrc = linkFieldSrc;